module.exports = __webpack_public_path__ + "static/best_req_smallbiz-3fc016b714daec420648922a724dee2b.svg";